import { render, staticRenderFns } from "./BookingProduct.vue?vue&type=template&id=1c3e384c&"
import script from "./BookingProduct.vue?vue&type=script&lang=js&"
export * from "./BookingProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports